import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

// Layouts
import MainLayout from './components/layouts/MainLayout';
import AuthLayout from './components/layouts/AuthLayout';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import MunicipioStats from './pages/MunicipioStats';
import FormSelection from './pages/FormSelection';
import AdminForms from './pages/AdminForms';
import DesenvolvimentoProdutivo from './pages/forms/DesenvolvimentoProdutivo';
import InfraestruturaEconomicaUrbana from './pages/forms/InfraestruturaEconomicaUrbana';
import DiagnosticoMunicipal from './pages/forms/DiagnosticoMunicipal';
import NotFound from './pages/NotFound';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-600"></div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <Routes>
      {/* Auth Routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
      </Route>
      
      {/* Protected Routes */}
      <Route element={
        <ProtectedRoute>
          <MainLayout />
        </ProtectedRoute>
      }>
        <Route path="/" element={<Navigate to="/forms" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/municipios" element={<MunicipioStats />} />
        <Route path="/forms" element={<FormSelection />} />
        <Route path="/admin/forms" element={<AdminForms />} />
        <Route path="/forms/desenvolvimento-produtivo" element={<DesenvolvimentoProdutivo />} />
        <Route path="/forms/infraestrutura-economica-urbana" element={<InfraestruturaEconomicaUrbana />} />
        <Route path="/forms/diagnostico-municipal" element={<DiagnosticoMunicipal />} />
      </Route>
      
      {/* 404 Route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
